import * as React from 'react';
import styled from 'styled-components';
import { NavLink } from 'react-router-dom';
import terms_logo from 'assets/img/landing/logo.svg'
import { LogosWrapper } from 'pages/landing/styles';
import bet_logo from 'assets/img/landing/bet_logo.svg';
import { HOCisTrue } from 'components/HOCisTrue';
import { useSelector } from 'react-redux';
import { getIsBettingAllowed } from 'modules/selectors';

const Wrapper = styled.div`
  font-size: 10px;
  line-height: 14px;
  font-family: Eund, sans-serif;
  padding: 0 20px 20px;
  font-style: italic;
  font-weight: bold;
  background: #000000;
  color: #FFFFFF;
  text-align: center;

  p {
	max-width: 1200px;
	margin: 0 auto;
  }

  @media (min-width: 1000px) {
	font-size: 18px;
	line-height: 40px;
	padding: 60px 100px;
  }

  @media screen and (max-width: 1000px) {
	padding: 20px;
  }

  ${LogosWrapper} {
	justify-content: center;
	font-style: normal;
  }
`;

const Logo = styled.img`
  @media screen and (max-width: 1000px) {
	height: 33px;
  }
`;

const Link = styled(NavLink)`
  color: #FFC600;
  font-family: EundBold, sans-serif;

  @media screen and (max-width: 1000px) {
	font-size: 8px;
	letter-spacing: 0;
	line-height: 11px;
  }
`;

const SLogosWrapper = styled(LogosWrapper)`
  @media screen and (max-width: 1000px) {
	margin-bottom: 18px;
	gap: 18px;
	h3 {
	  font-size: 10px !important;
	  margin-bottom: 0 !important;
	  line-height: 14px !important;
	}

	div > img {
	  height: 22px;
	}
  }
`

const FooterOfferText = styled.p`
  font-weight: bold;
  margin-top: 40px !important;

  a {
	text-decoration: underline;
  }

  a, b {
	color: #FFC600;
	font-weight: bold;
  }

  @media screen and (max-width: 1000px) {
	margin-top: 12px !important;
  }
`;

export const Terms: React.FC = () => {
	const isBettingAllowed = useSelector(getIsBettingAllowed);
	return (<Wrapper>
			<SLogosWrapper>
				<Logo src={terms_logo}/>
				<HOCisTrue when={isBettingAllowed}>
					<div>
						<h3>Presented by</h3>
						<img src={bet_logo} alt="Bet logo"/>
					</div>
				</HOCisTrue>

			</SLogosWrapper>
			<p>
				<b>NO PURCHASE NECESSARY TO ENTER OR WIN</b>. Open to legal residents of US & DC, 21 or older. Must have
				valid
				account on the BWW app to participate. Begins on or about 8/1/20 and ends on or about 12/31/21. For full
				details, including number, description and ARV of prizes, and entry and game play terms, see <Link
				to={'/rules'}>official rules</Link>
				, available at participating restaurants or online at <Link
				to={'/rules'}>play.buffalowildwings.com/rules</Link>. Void where prohibited
				by law.
				Sponsor: Buffalo Wild Wings, Inc. Three Glenlake Parkway NE Atlanta, GA 30328.
			</p>
			<FooterOfferText id="mgm-terms">
				21+ years of age or older to wager. AZ, CO, DC, IA, IL, IN, LA, MI, MS, NJ, NV, NY, PA, TN, VA, WV, or
				WY only. Visit <a href="https://BetMGM.com">BetMGM.com</a> for Terms and Conditions. New Customer Offer.
				All promotions are subject to
				qualification and eligibility requirements. Rewards issued as non-withdrawable free bets or site credit.
				Free bets expire in 7 days from issuance. Excludes Michigan Disassociated Persons. Please Gamble
				Responsibly. Gambling problem? Call 1-800-NEXT-STEP (AZ), 1-800-522-4700 (CO, DC, LA, NV, WY, VA),
				1-800-270-7117 for confidential help (MI), 1-800-GAMBLER (IL, IN, NJ, PA & WV), 1-800-BETS OFF (IA)
				or Call (877-8-HOPENY) or text HOPENY (467369) (NY), call or text the Tennessee REDLINE:
				800-889-978 (TN)
				or call 1-888-777-9696 (MS). Sports betting is void where prohibited. Promotional offers not available
				in Nevada.
			</FooterOfferText>
		</Wrapper>
	);
}
